package fr.arcplex.network.http

enum class ResponseType {
    Success, Informational, Redirection, ClientError, ServerError
}

sealed class ApiInfrastructureResponse<out T>(val responseType: ResponseType) {
    abstract val statusCode: Int
    abstract val headers: Map<String, List<String>>
}

data class Success<T>(
        val data: T,
        override val statusCode: Int = -1,
        override val headers: Map<String, List<String>> = mapOf()
) : ApiInfrastructureResponse<T>(ResponseType.Success)

data class Informational<out T>(
        val statusText: String,
        override val statusCode: Int = -1,
        override val headers: Map<String, List<String>> = mapOf()
) : ApiInfrastructureResponse<T>(ResponseType.Informational)

data class Redirection<out T>(
        override val statusCode: Int = -1,
        override val headers: Map<String, List<String>> = mapOf()
) : ApiInfrastructureResponse<T>(ResponseType.Redirection)

data class ClientError<T>(
        val body: Any? = null,
        override val statusCode: Int = -1,
        override val headers: Map<String, List<String>> = mapOf()
) : ApiInfrastructureResponse<T>(ResponseType.ClientError)

data class ServerError<T>(
        val message: String? = null,
        val body: Any? = null,
        override val statusCode: Int = -1,
        override val headers: Map<String, List<String>>
) : ApiInfrastructureResponse<T>(ResponseType.ServerError)
